import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-sku-customer',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorSkuCustomerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
